import groupByDate from "@irati/wallet/helpers/groupWalletItemsByDate"
import {LIST_STATEMENT_ITEMS, CLEAR_STATEMENT_ITEMS, ActionTypes} from "../actions/StatementItem"

const defaultState = {
  results: null,
  currency: null
}

const StatementItemReducer = (state = defaultState, action: ActionTypes) => {
  switch (action.type) {
    case LIST_STATEMENT_ITEMS: {
      const {existingStatementItems, newStatementItems, currency} = action
      return {
        ...state,
        currency,
        ...groupByDate(existingStatementItems, newStatementItems)
      }
    }
    case CLEAR_STATEMENT_ITEMS:
      return {
        ...state,
        results: null
      }
    default:
      return state
  }
}

export default StatementItemReducer
